<template>
  <span v-if="element === 'span'" v-bind="$attrs">{{ computedText }}</span>

  <strong v-if="element === 'strong'" v-bind="$attrs">{{
    computedText
  }}</strong>

  <p v-if="element === 'p'" v-bind="$attrs">{{ computedText }}</p>

  <h1 v-if="element === 'h1'" v-bind="$attrs">{{ computedText }}</h1>
  <h2 v-if="element === 'h2'" v-bind="$attrs">{{ computedText }}</h2>
  <h3 v-if="element === 'h3'" v-bind="$attrs">{{ computedText }}</h3>
  <h4 v-if="element === 'h4'" v-bind="$attrs">{{ computedText }}</h4>
  <h5 v-if="element === 'h5'" v-bind="$attrs">{{ computedText }}</h5>
  <h6 v-if="element === 'h6'" v-bind="$attrs">{{ computedText }}</h6>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    translationParams: {
      type: Object,
      default: () => ({}),
    },
    element: {
      type: String,
      default: "span",
    },
    translationFunction: {
      type: String,
      default: "tu",
    },
  },
  computed: {
    computedText() {
      return this[this.translationFunction](this.text, this.textParams);
    },
  },
};
</script>
